import React, {useState} from 'react';
import {ReactComponent as DragIcon} from '../../../../../../../assets/i/drag.svg';
import useOutsideClick from "common/hook/useOutsideClick";
import {endMeeting} from "features/model/service/lessons/lessons-button/end-meeting/endMeeting";
import {fetchLessonsId} from "features/model/service/groups/lessons/fetchLessonsId";
import {useParams} from "react-router-dom";
import {useAppDispatch} from "common/hook";
import {endLesson} from "features/model/service/lessons/lessons-button/end-lesson/endLesson";
import {LessonData} from "features/model/types/lessosnSchema";


interface DetailsPopupProps {
    lesson: LessonData
}

export const DetailsPopup = ({lesson}: DetailsPopupProps) => {
        const dispatch = useAppDispatch();
        const [open, setOpen] = useState(false);
        const {lessonsId} = useParams();
        const popupRef = useOutsideClick(() => setOpen(false));
        const togglePopup = () => {
            setOpen(prevState => !prevState);
        };

        const closePopup = () => {
            setOpen(false);
        };

        const EndMeetingHandler = async () => {
            if (lessonsId) {
                await dispatch(endMeeting(lessonsId));
                await dispatch(fetchLessonsId(lessonsId));
            }
        };

        const EndLessonHandler = async () => {
            if (lessonsId) {
                await dispatch(endLesson(lessonsId));
                await dispatch(fetchLessonsId(lessonsId));
            }
        };

        return (
            <div className='details-popup col action-col' ref={popupRef}>
                <DragIcon onClick={togglePopup}/>
                {open && (
                    <div className='details-popup-block' onClick={closePopup}>
                        <div
                            className="profile"
                            onClick={EndMeetingHandler}
                        >
                            Завершить сессию BBB
                        </div>
                        <div
                            className="exit"
                            onClick={EndLessonHandler}
                        >
                            Завершить занятие
                        </div>
                    </div>
                )}
            </div>
        );
    }
;

// <div
//     className="exit"
//     onClick={EndMeetingHandler}
// >
//     <a
//         style={{boxShadow: 'none'}}
//         href={lesson.link}
//         target="_blank"
//         rel="noopener noreferrer"
//     >
//         Завершить занятие
//     </a>
// </div>
